import { useEffect, useState } from "react";
import api from "../lib/api";
import { Link, useNavigate } from "react-router-dom";
import { Gamepad2, Sparkles, ArrowLeft, Play } from "lucide-react";

export default function Games() {
  const [games, setGames] = useState([]);
  const nav = useNavigate();

  useEffect(() => { api.get("/games").then(r => setGames(r.data || [])); }, []);

  const open = (g) => {
    if (g.coming_soon) return;
    if (g.play_url?.startsWith("http")) window.open(g.play_url, "_blank");
    else if (g.play_url) nav(g.play_url);
  };

  return (
    <div className="px-4 py-6 pb-24" data-testid="games-page">
      <Link to="/more" className="flex items-center gap-1 text-xs text-white/60 mb-3" data-testid="games-back"><ArrowLeft className="w-3.5 h-3.5"/>Back</Link>
      <div className="flex items-center gap-2 mb-1">
        <Gamepad2 className="w-7 h-7 text-[#34D399]"/>
        <h1 className="font-outfit font-extrabold text-3xl tracking-tighter">Games</h1>
      </div>
      <p className="text-white/60 text-sm mb-4">Play, predict and battle to earn Goldly &amp; Tokwin</p>

      <div className="grid grid-cols-2 gap-3" data-testid="games-grid">
        {games.map(g => (
          <button key={g.id} onClick={() => open(g)} data-testid={`game-${g.id}`}
            className="relative aspect-[3/4] rounded-2xl overflow-hidden border border-white/10 active:scale-95 transition text-left"
            style={{ backgroundImage: g.cover_url ? `url(${g.cover_url})` : undefined, backgroundSize: "cover", backgroundPosition: "center", backgroundColor: "#1a1f2e" }}>
            <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, transparent 40%, #000000ee 100%)" }}/>
            {g.coming_soon ? (
              <div className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-[#FF7A00]/90 text-black text-[10px] font-extrabold flex items-center gap-1">
                <Sparkles className="w-3 h-3"/>SOON
              </div>
            ) : g.free_until_promo ? (
              <div className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-gradient-to-r from-[#FF7A00] to-[#FF7A00] text-black text-[10px] font-extrabold flex items-center gap-1 animate-pulse">
                <Sparkles className="w-3 h-3"/>FREE LTD
              </div>
            ) : (
              <div className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-[#34D399]/90 text-black text-[10px] font-extrabold flex items-center gap-1">
                <Play className="w-3 h-3 fill-black"/>PLAY
              </div>
            )}
            <div className="absolute bottom-0 inset-x-0 p-3">
              <h3 className="font-outfit font-extrabold text-base text-white leading-tight drop-shadow-lg">{g.title}</h3>
              <p className="text-white/75 text-[10px] mt-0.5 line-clamp-2">{g.description}</p>
            </div>
          </button>
        ))}
        {games.length === 0 && <div className="col-span-2 text-center text-white/40 text-sm py-8">Games loading…</div>}
      </div>
    </div>
  );
}
